var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagMuestras(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#163C5B",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320-300v-60h110q-5 14-7 29t-3 31H320Zm0 220q-83 0-141.5-58.5T120-280v-360q-33 0-56.5-23.5T40-720v-80q0-33 23.5-56.5T120-880h400q33 0 56.5 23.5T600-800v80q0 33-23.5 56.5T520-640v150q-9 7-17 14.5T487-460H320v-60h140v-120H180v360q0 58.33 40.83 99.17Q261.67-140 320-140q36 0 66.5-17t49.5-45q6 15.71 13.5 29.86Q457-158 467-144q-28 30-65.52 47Q363.95-80 320-80ZM100-700h440v-120H100v120Zm569.86 520Q716-180 748-211.86t32-78Q780-336 748.14-368t-78-32Q624-400 592-368.14t-32 78Q560-244 591.86-212t78 32ZM874-44 767-151q-22 15-46.32 23-24.33 8-50.68 8-70.83 0-120.42-49.62Q500-219.24 500-290.12t49.62-120.38q49.62-49.5 120.5-49.5t120.38 49.58Q840-360.83 840-290q0 26.35-8 50.68Q824-215 809-193L916-86l-42 42ZM100-700v-120 120Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagMuestras);
export default __webpack_public_path__ + "static/media/DiagMuestras.74365fef506077960639a6d50ad377fa.svg";
export { ForwardRef as ReactComponent };